import { useState } from 'react';

import { useHandlePaymentMethod } from '../hooks/useHandlePaymentMethod';

import icCard from '@/assets/myAccount/ic_creditcard.png';
import icLink from '@/assets/myAccount/ic_linkpagos.png';
import icCuentas from '@/assets/myAccount/ic_pagomiscuentas.png';
import { Button, Tags } from '@/components';
import { TipoProductoTO } from '@/types/myAccount';
import { PAYMENT_METHODS, PAYMENT_METHODS_BY_ID, PaymentMethod } from '@/utils';

export const PaymentMethodSelector = ({
  product,
  amountToWallet,
}: {
  product?: TipoProductoTO;
  amountToWallet?: number;
}) => {
  const [selected, setSelected] = useState<PaymentMethod | null>();
  const { handlePaymentMethod } = useHandlePaymentMethod();

  const classButtonTag =
    'lg:flex w-full text-left lg:justify-center h-[46px] text-sm lg:text-gdt-blue text-gdt-gray-2 border-gdt-gray-xl2 flex items-center p-0';

  const handleIsChecked = (methodSelected: number) => {
    return selected?.id === methodSelected;
  };

  return (
    <div className="p-6 flex flex-col justify-around flex-1 lg:p-0 mt-2">
      <strong className="text-sm text-gdt-gray lg:text-center lg:font-semibold">
        Seleccioná el método de pago
      </strong>
      <div className="flex-1">
        <ul className="space-y-4 lg:space-y-2 mt-5">
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.DEB_CRED.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.DEB_CRED.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icCard} width={21} />
              </figure>
              <span>Tarjeta de crédito o débito</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.PAGO_MIS_CUENTAS.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.PAGO_MIS_CUENTAS.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icCuentas} width={33} />
              </figure>
              <span>Pago Mis Cuentas</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.LINK_PAGOS.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.LINK_PAGOS.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icLink} width={25} />
              </figure>
              <span>Link Pagos</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.PAGO_FACIL.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.PAGO_FACIL.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <span className="pl-5 lg:p-0">
                Pago Fácil / Rapipapago / Cobro Express
              </span>
            </Tags.Checkbox>
          </li>
        </ul>
      </div>
      <div className="">
        <Button
          className="w-full lg:mt-5"
          disabled={!selected}
          type="button"
          variant="primary"
          onClick={() => {
            handlePaymentMethod({
              product,
              moneyToWallet: amountToWallet,
              paymentMethod:
                selected && selected.id && PAYMENT_METHODS_BY_ID[selected?.id],
            });
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};
